import { render, staticRenderFns } from "./BidInformation.vue?vue&type=template&id=afed64fe"
import script from "./BidInformation.vue?vue&type=script&lang=js"
export * from "./BidInformation.vue?vue&type=script&lang=js"
import style0 from "./BidInformation.vue?vue&type=style&index=0&id=afed64fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports